"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseValidator = /** @class */ (function () {
    function BaseValidator(parsedJSON) {
        this.parsedJSON = parsedJSON;
        this.result = [];
        this.parsedJSON = parsedJSON;
    }
    // Push to result
    // Todo[@taoning2014]: Push the `ParseError` into the result array directly instead of destructing it
    BaseValidator.prototype.addToResult = function (validationError) {
        this.result.push(validationError);
    };
    return BaseValidator;
}());
exports.default = BaseValidator;
